export default "__VITE_ASSET__JhDLFXEk__"